export enum NestedNodeType {
    VIDEO,
    AVATAR,
    QUESTION,
    TEXT_ANSWERS,
    VOICE_ANSWERS,
    IMAGE,
    AUDIO,
    TEXT_SLIDE,
    INFOS
}